// extracted by mini-css-extract-plugin
export default {"accordionActive":"AccordionWindow_accordionActive__4tWnu","accordionHead":"AccordionWindow_accordionHead__UA6wS","accordionContent":"AccordionWindow_accordionContent__e2zoJ"};